require('../filter-editor-modal.component.scss');
require('./stamprecognition-filter-editor.component.scss');

export class stamprecognitionFilterEditorController {

  constructor($scope, $http, CurrentModelService, FileUploader, FiltersService, FilterResource) {
    this.$scope = $scope;
    this.$http = $http;
    this.FileUploader = FileUploader;
    this.CurrentModelService = CurrentModelService;
    this.FiltersService = FiltersService;
    this.FilterResource = FilterResource;
    this.$scope.uploader = new FileUploader({});
    this.uploader = this.$scope.uploader;
    const uploader = this.uploader;

    // FILTERS
    uploader.filters.push({
      name: 'imageFilter',
      fn: function(item /*{File|FileLikeObject}*/, options) {
        const type = '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';
        return '|jpg|png|jpeg|bmp|gif|'.indexOf(type) !== -1;
      }
    });

  }

  $onInit() {

    const scope = this.$scope;
    this.$scope.filter = this.filter.filter;
    const staffcop_filter = this.$scope.filter;
    const FiltersService = this.FiltersService;
    const uploader = this.uploader;
    uploader.url = '/cp_queue/upload_stamp_targets/' + this.filter.filter.id;
    const FileUploader = this.FileUploader;
    const update_target_list = function() {
      let target_list = '';
      uploader.queue.filter(q => q.isSuccess).forEach(fileItem => {
        target_list += '\n' + fileItem.file.name;
      });
      //         scope.filter._changed = true;
      //         scope.filter.isChanged = true;
      //         console.log(scope.filter);
      scope.filter.stamp_target_files = target_list;
    };

    uploader.remove = function(item) {
      item.remove();
      update_target_list();
    };

    uploader.onErrorItem = function(fileItem, response, status, headers) {
      //         console.info('onErrorItem', fileItem, response, status, headers);
      alert(gettext('Ошибка ') + status);
    };

    uploader.onCompleteItem = function(fileItem, response, status, headers) {
      //         console.info('onCompleteItem', fileItem, response, status, headers);
      if (response.existence != undefined && response.existence.includes('check_api_conection')) {
        fileItem._onTimeout();
        alert(gettext('Пожалуйста, проверьте подключение к API модуля контентного анализа!'));
      } else if (response.existence != undefined && response.existence.includes('no_stamp_detected')) {
        fileItem._onTimeout();
        alert(gettext('Печати не обнаружены на изображении!'));
      } else {
        update_target_list();
      }
    };

    const target_list = this.filter.filter.stamp_target_files;
    if (target_list != undefined) {
      const uploaded_targets = target_list.trim().split('\n').filter(i => (i));
      uploaded_targets.forEach((target) => {
        const url = '/media/stamp_targets/' + this.filter.filter.id + '/' + target;
        const file_name = target.split('/').pop();
        this.$http.get(url, {
          responseType: 'blob'
        }).then(function({
          data
        }) {
          const mimetype = data.type;
          const file = new File([data], target, {
            type: mimetype
          });
          const dummy = new FileUploader.FileItem(uploader, {
            lastModifiedDate: new Date(),
            size: data.size,
            type: mimetype,
            name: file_name
          });
          dummy._file = file;
          dummy.progress = 100;
          dummy.isUploaded = true;
          dummy.isSuccess = true;
          uploader.queue.push(dummy);
        });
      });
    }

  }

  uploadItem(fileItem) {
    const uploader = this.uploader;
    const scope = this.$scope;
    const filters = this.FiltersService.filters;
    if (!this.filter.filter.id) {
      this.FilterResource.save(this.filter.filter).then(({
        status,
        data,
        error
      }) => {
        if (status === 200) {
          //                     filters.push(scope.filter);
          uploader.url = '/cp_queue/upload_stamp_targets/' + data.id;
          fileItem.url = uploader.url;
          fileItem.upload();
        } else {
          alert('Error saving filter: ' + status);
          console.log(data);
        }
      });
    } else {
      fileItem.url = uploader.url;
      fileItem.upload();
    }
  }

  get filterText() {
    return JSON.stringify(this.filter, undefined, 2);
  }

}

class ngThumbComponent {
  constructor($window) {

    const helper = {
      support: !!($window.FileReader && $window.CanvasRenderingContext2D),
      isFile: function(item) {
        return angular.isObject(item) && item instanceof $window.File;
      },
      isImage: function(file) {
        const type = '|' + file.type.slice(file.type.lastIndexOf('/') + 1) + '|';
        return '|jpg|png|jpeg|bmp|gif|'.indexOf(type) !== -1;
      }
    };

    return {
      restrict: 'A',
      template: '<canvas/>',
      link: function(scope, element, attributes) {
        if (!helper.support) return;

        const params = scope.$eval(attributes.ngThumb);

        if (!helper.isFile(params.file)) return;
        if (!helper.isImage(params.file)) return;

        const canvas = element.find('canvas');
        const reader = new FileReader();

        reader.onload = onLoadFile;
        reader.readAsDataURL(params.file);

        function onLoadFile(event) {
          const img = new Image();
          img.onload = onLoadImage;
          img.src = event.target.result;
        }

        function onLoadImage() {
          const width = params.width || this.width / this.height * params.height;
          const height = params.height || this.height / this.width * params.width;
          canvas.attr({
            width: width,
            height: height
          });
          canvas[0].getContext('2d').drawImage(this, 0, 0, width, height);
        }
      }
    };
  }

  static directiveFactory($window) {
    ngThumbComponent.instance = new ngThumbComponent($window);
    return ngThumbComponent.instance;
  }
}

ngThumbComponent.directiveFactory.$inject = ['$window'];

export const StamprecognitionFilterEditorComponent = {
  bindings: {
    filter: '<',
  },
  template: require('./stamprecognition-filter-editor.component.html'),
  controller: stamprecognitionFilterEditorController,
};

export {
  ngThumbComponent
};



// WEBPACK FOOTER //
// ./src/filter/editor/spec-forms/stamprecognition-filter-editor.component.js